import domReady from '@wordpress/dom-ready';

domReady(() => {
  document.querySelectorAll('.tab-container').forEach((tabContainer) => {
    const buttonGroup = document.createElement('div');
    buttonGroup.classList.add('tab-buttons');
    tabContainer.prepend(buttonGroup);

    const buttons = Array.from(tabContainer.querySelectorAll('.tab-button'));
    const tabs = Array.from(tabContainer.querySelectorAll('.tab'));

    const showTab = (index) => {
      buttons.forEach((button) => {
        if (buttons.indexOf(button) !== index) {
          button.setAttribute('aria-selected', 'false');
          button.setAttribute('tabindex', '-1');
          button.classList.remove('active');
        } else {
          button.setAttribute('aria-selected', 'true');
          button.setAttribute('tabindex', '0');
          button.classList.add('active');
        }
      });
      tabs.forEach((tab) => {
        if (tabs.indexOf(tab) !== index) {
          tab.style.display = 'none';
          tab.classList.remove('active');
        } else {
          tab.style.display = '';
          tab.classList.add('active');
        }
      });
    };

    buttons.forEach((button) => {
      buttonGroup.append(button);
      button.addEventListener('click', () => {
        showTab(buttons.indexOf(button));
      });
      button.addEventListener('keydown', () => {
        switch (event.key) {
          case 'ArrowLeft':
            if (!button.previousSibling) {
              buttons[buttons.length - 1].focus();
            } else {
              button.previousSibling.focus();
            }
            break;
          case 'ArrowRight':
            if (!button.nextSibling) {
              buttons[0].focus();
            } else {
              button.nextSibling.focus();
            }
            break;
        }
      });
    });

    showTab(0);
  });
});
